import {FocusMonitor} from '@angular/cdk/a11y';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {Component, ElementRef, Input, OnDestroy, Optional, Self} from '@angular/core';
import {FormBuilder, FormGroup, ControlValueAccessor, NgControl} from '@angular/forms';
import {MatFormFieldControl} from '@angular/material/form-field';
import {Subject} from 'rxjs';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ContactService } from '../../shared/services/contact.service';
import { ZipCodeService } from '../../shared/services/zip-code.service';
import {FormControl} from '@angular/forms';
import {debounceTime, switchMap, tap} from 'rxjs/operators';
import { Contact } from '../../shared/models/contact';
/** Custom `MatFormFieldControl` for telephone number input. */
@Component({
  selector: 'app-contact-input',
  templateUrl: 'contact-input.component.html',
  styleUrls: ['contact-input.component.scss'],
   providers: [        
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ContactInputComponent,
            multi: true,
        }
    ]  

})
export class ContactInputComponent implements ControlValueAccessor {

	@Input() placeholder: string;
	@Input() errors: string;

  nameCtrl = new FormControl();
  zipCtrl = new FormControl();
  localityCtrl = new FormControl();  
  streetCtrl = new FormControl();  

	id: number;

  filteredContacts: any;
  contact: Contact = new Contact; 

  localities: any[]= [];

	constructor(
      private contactService: ContactService,
      private zipCodeService: ZipCodeService,
      private fb: FormBuilder
	) { 

 

      this.filteredContacts = this.nameCtrl
          .valueChanges
          .pipe(
              debounceTime(300),
              tap(value => this._propagateChange(value)),
              switchMap(value => {
                return this.contactService.getAll('name', 2, {name: {value:value}},0,20);
              }),
           );
  }
 
  	propagateChange = (_: any) => {};
  	
  	ngOnInit() {    
      this.nameCtrl.valueChanges.subscribe(v => { 
        if (v) {
          this.zipCtrl.patchValue(v.zip_code);
          this.localityCtrl.patchValue(v.locality);
          this.streetCtrl.patchValue(v.street);
          
        } 
      });

      this.streetCtrl.valueChanges.subscribe(v => {this._propagateChange(this.nameCtrl.value);});
      this.localityCtrl.valueChanges.subscribe(v => {this._propagateChange(this.nameCtrl.value);});

      this.zipCtrl.valueChanges.subscribe(v => { 
        this._propagateChange(this.nameCtrl.value);
        this.zipCodeService.get(v).subscribe(data => {
          this.localities = data;
          if (data && data.length == 1) {
            this.localityCtrl.patchValue(data[0].name);
          }
        });
      });    

  	}
    displayFn(contact?: Contact): string | undefined {            
      return contact ? contact.name : undefined;
    }

  	onChange(event) {
  		this.propagateChange(event.value);
  	}

    _propagateChange(value: any) {

      const c = Object.assign(
        {id: value && value.id ? value.id : null},
        {name: value && value.name ? value.name : value },
        {street: this.streetCtrl.value ? this.streetCtrl.value : value.street},
        {locality: this.localityCtrl.value ? this.localityCtrl.value : value.locality},
        {zip_code: this.zipCtrl.value ? this.zipCtrl.value : value.zip_code},

       );      
      this.propagateChange(c);
    }

    writeValue(obj: any): void {      
      this.nameCtrl.patchValue(obj);
      if (obj) {
        this.streetCtrl.patchValue(obj.street);
        this.zipCtrl.patchValue(obj.zip_code);
        this.localityCtrl.patchValue(obj.locality);        
      }
    	//this.contact = obj;
      
    	
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;        
    }

    registerOnTouched(fn: any): void { }

    setDisabledState?(isDisabled: boolean): void { }
}